import { useContextFallback } from '@prenuvo/halo-foundation';

import { ReportIssueHandlerContext } from './report-issue-handler.context';

export const useReportIssueHandler = () => useContextFallback(ReportIssueHandlerContext);
